module.exports = `fragment locations_map on Contentstack_locations_map {
    heading
    subheading
    enabled
    inject_data
    disable_tooltips
    disable_listing
    display_on_desktop_only_locations_map
  }`;